export default "__VITE_ASSET__gVhbiXnT__"